import React, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

const TruckerProfileSkeletonMF = React.lazy(() => import('truckerProfile/Skeleton'));

const TruckerProfileSkeleton = () => {
  const fallbackRender = (): JSX.Element => null;

  return (
    <ErrorBoundary onReset={() => null} fallbackRender={fallbackRender} data-testid="error-boundary">
      <Suspense fallback={null}>
        <TruckerProfileSkeletonMF />
      </Suspense>
    </ErrorBoundary>
  );
};

export default TruckerProfileSkeleton;
